import { render } from "./WeekdayPicker.vue?vue&type=template&id=1fff280b&scoped=true"
import script from "./WeekdayPicker.vue?vue&type=script&lang=ts"
export * from "./WeekdayPicker.vue?vue&type=script&lang=ts"

import "./WeekdayPicker.vue?vue&type=style&index=0&id=1fff280b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1fff280b"

export default script